<template>
    <div class="form-group">
        <label :for="id">{{ label }}<span v-if="required" class="text-danger">*</span></label>
        <v-select :id="id" :value="modelValue" @change="e => $emit('input ', e)" :options="options" :reduce="reduce"
            :label="labelField" :placeholder="placeholder" @search="onSearch"
            :class="validation && validation.length > 0 ? 'is-invalid' : ''">
            <template v-slot:no-options>
                <slot name="no-options">Type here to search {{ label.toLowerCase() }}...</slot>
            </template>
        </v-select>
        <small v-if="validation && validation.length > 0" class="text-danger">
            {{ validation.join(', ') }}
        </small>
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    components: {
        vSelect,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: '',
        },
        options: {
            type: Array,
            required: true,
        },
        reduce: {
            type: Function,
            required: false,
        },
        onSearch: {
            type: Function,
            required: false,
        },
        labelField: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: 'Type to search...',
        },
        validation: {
            type: Array,
            default: () => [],
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
